export default __webpack_public_path__ + "static/media/category_7.79b96123.png";